// Tarjeta de sección de la ficha (`.fcard` del mock): título en versalitas, nota a la derecha y cuerpo.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function DetailCard({
    title,
    aside,
    flush = false,
    children,
}: {
    title: string;
    aside?: ReactNode;
    flush?: boolean;
    children: ReactNode;
}) {
    return (
        <section
            aria-label={title}
            className="mb-2 overflow-hidden rounded-md border border-border bg-card"
        >
            <div className="flex items-center justify-between border-b border-border bg-muted/30 px-2.5 py-1">
                <span className="text-[9.5px] font-bold uppercase tracking-[0.04em] text-muted-foreground">
                    {title}
                </span>
                {aside ? <span className="text-[9.5px] text-muted-foreground">{aside}</span> : null}
            </div>
            <div className={cn(!flush && 'px-2.5 py-2')}>{children}</div>
        </section>
    );
}

/** Aviso en cursiva y centrado de una sección sin datos. */
export function DetailEmpty({ children }: { children: ReactNode }) {
    return (
        <div className="px-4 py-5 text-center text-[11px] italic text-muted-foreground">
            {children}
        </div>
    );
}

export const DETAIL_TH =
    'sticky top-0 z-[1] border-b border-border bg-muted/30 px-2.5 py-1.5 text-left text-[9.5px] font-bold uppercase tracking-[0.04em] text-muted-foreground';

/** Celda en una sola línea: el renglón mide lo mismo en toda la tabla (DEC-47). */
export const DETAIL_TD = 'whitespace-nowrap border-b border-border/40 px-2.5 py-1.5 align-middle';

/** Id chico en mono bajo un nombre (`.c-cli-id` del mock). */
export function MonoId({ children }: { children: ReactNode }) {
    return (
        <span className="mt-px block truncate font-mono text-[9.5px] text-muted-foreground">
            {children}
        </span>
    );
}
